import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {TripService} from '../../trip.service';

@Component({
  selector: 'app-edit-hotel-check-in-out',
  templateUrl: './edit-hotel-check-in-out.component.html',
  styleUrls: ['./edit-hotel-check-in-out.component.css', '../../../app.component.css', '../../admin.css'],
  providers: [TripService]
})
export class EditHotelCheckInOutComponent implements OnInit {
  errorMessage : any;
  Info: any;
  travelInfo:any;
  type:any;
  spinner: boolean = false;
  eventUserId:any;

  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<EditHotelCheckInOutComponent>, private formBuilder: FormBuilder, private tripService: TripService,private snackBar: MdSnackBar) { }

  ngOnInit() {
    this.travelInfo={
      arriveByPlane : (this.Info.arriveByPlane==1)?this.Info.arriveByPlane:0,
    };
    this.Info.arriveDateTime=(this.Info.arriveByPlane==1)?this.Info.arriveDateTime:'';
    this.Info.returnDateTime=(this.Info.arriveByPlane==1)?this.Info.returnDateTime:'';
    this.travelInfo={
      userId:this.Info.userId,
      eventId : this.Info.eventId,
      eventUserId:this.Info.id,
      checkIn : (this.Info.checkIn)?this.Info.checkIn:'',
      checkIns : (this.Info.checkIn)?this.Info.checkIn:'',
      checkOut : (this.Info.checkOut)?this.Info.checkOut:'',
      checkOuts : (this.Info.checkOut)?this.Info.checkOut:'',
    };
  }

  editAtt(info){
    if(info.valid){
      this.travelInfo.checkIn = this.toSqlTime(this.travelInfo.checkIns);
      this.travelInfo.checkOut = this.toSqlTime(this.travelInfo.checkOuts);
      this.spinner = true;
      this.tripService.updateHotelCheckInOut({  travelInfo:this.travelInfo, type:this.type }).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.snackBar.open('Hotel Information updated successfully','',{duration:4000});
              this.dialogRef.close();
            }
            else{
              this.snackBar.open(response.msg,'',{duration:4000});
              this.spinner = false;
            }
          },
              error => {
            this.spinner = false;
          }
      );

    }
  }

  dateTimeFormat(dt){
    if(dt)
    {
      var m = dt.getMonth()+1;
      if(m<10)
        m='0'+m;
      var d = dt.getDate();
      if(d<10)
        d='0'+d;
      return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
    }
    else
      return '';
  }

  //toSqlTime(dt){
  //  var s = '';
  //  if(dt && typeof(dt)=='object')
  //  {
  //    s += dt._d.toLocaleDateString();
  //    s += ' ';
  //    s += dt._d.toTimeString().split(' ')[0];
  //  }
  //  return s;
  //}
  toSqlTime(dt){
    var s = '';
    if(dt)
    {
      if(typeof(dt)=='object')
      {
        s += dt._d.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
        s += ' ';
        s += dt._d.toTimeString().split(' ')[0];
      }
      else
        return dt;
    }
    return s;
  }

  toUsSqlTime(dt){
    var s = '';
    if(dt && typeof(dt)=='object')
    {
      s += dt._d.toLocaleDateString();
      s += ' ';
      s += dt._d.toLocaleTimeString();
    }
    return s;
  }

  close() {
    this.dialogRef.close();
  }

  triggerClick(id){
    (<HTMLInputElement>window.document.getElementById(id)).click()
  }

  validateDate(dt){
    if(!dt)
      return false;
    dt = new Date(dt);
    return (dt!='Invalid Date');
  }


}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/edit-hotel-check-in-out/edit-hotel-check-in-out.component.ts